import { render } from "./RiceDivider.vue?vue&type=template&id=6636f656&scoped=true"
import script from "./RiceDivider.vue?vue&type=script&lang=js"
export * from "./RiceDivider.vue?vue&type=script&lang=js"

import "./RiceDivider.vue?vue&type=style&index=0&id=6636f656&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6636f656"]])

export default __exports__